import { createFileRoute } from "@tanstack/react-router"
import { AlertCircle } from "lucide-react"

import { getUserEmail } from "@/lib/auth"
import { useMediaQuery } from "@/hooks/use-media-query"
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import { MobileTrustDevice } from "@/components/forms/mobile-trust-device"
import { Icons } from "@/components/icons"

export const Route = createFileRoute("/_auth/unknown-device")({
  component: Page,
})

function obfuscateEmail(email: string): string {
  const [localPart, domainPart] = email.split("@")
  const obfuscatedLocal =
    localPart[0] + "*".repeat(localPart.length - 2) + localPart.slice(-1)
  const [domainName, domainExtension] = domainPart.split(".")
  const obfuscatedDomain =
    domainName[0] + "*".repeat(domainName.length - 2) + domainName.slice(-1)
  return `${obfuscatedLocal}@${obfuscatedDomain}.${domainExtension[0]}*${domainExtension.slice(-1)}`
}

function Page() {
  const email = getUserEmail()
  const obfuscatedEmail = obfuscateEmail(email)
  const isDesktop = useMediaQuery("(min-width: 768px)")

  return (
    <div className="w-full px-5">
      <div className="flex flex-col items-center justify-center md:flex-row md:text-center">
        <Icons.himo
          className="mt-19 xs:hidden md:block"
          height="120px"
          width="120px"
        />
      </div>
      <div className="flex flex-col items-center justify-center md:flex-row md:text-center">
        <div className="relative md:h-[80px] md:w-[120px]">
          <Icons.phoneDark className="hidden w-full md:block" />
          <Icons.redDot
            className="absolute right-0 top-0 -translate-y-1/2 translate-x-1/2 transform"
            height="15px"
            width="15px"
          />
        </div>
        <div className="relative mb-4 mt-4 md:hidden">
          <Icons.phoneDark height="40px" width="40px" />
          <Icons.redDot
            className="absolute right-0 top-0 -translate-y-1/2 translate-x-1/2 transform"
            height="15px"
            width="15px"
          />
        </div>
        <div className="flex flex-col items-center justify-center text-center md:ml-6 md:items-start md:text-start">
          <h1 className="font-gilroy-bold text-[24px] text-primary">
            Unknown Device
          </h1>
          <p className="font-gilroy-thin text-[14px] opacity-70 xs:px-12 md:mt-1 md:px-0">
            Unrecognized device login detected. For your security, verify your
            identity to continue.
          </p>
        </div>
      </div>
      <div className="text-center xs:mt-2 md:mt-8">
        <p className="font-gilroy-thin inline text-sm opacity-70 md:block">
          The email is sent to{" "}
        </p>
        <p className="font-gilroy-bold inline text-sm text-neutral-800 dark:text-white md:block">
          {obfuscatedEmail}.
        </p>
        <div className="flex justify-center">
          {isDesktop ? null : <MobileTrustDevice />}
        </div>
      </div>
      <div className="flex items-center justify-center space-x-2 xs:mt-24 md:mt-10 md:justify-end">
        <p className="font-gilroy-thin text-[16px]">By</p>
        <Icons.hirayaWText width="90" />
      </div>
    </div>
  )
}
